<template>
  <div class="row-md-12">
    <div class="row mt-5">
      <div class="col-md-12">
        <create-user-form v-if="showCreateUserForm" @close="closeCreateUserForm" @refreshData="fetchData"></create-user-form>
      </div>
      <div class="col-12">
        <card card-body-classes="table-full-width" :title="$t('users.users')" :on-add-object="canCreateUser ? openCreateUserForm : null">
          <template v-if="enableExcelExport && userRole !== 'User'" #under-header>
            <div style="padding: 0 0 8px;">
              <el-button :icon="Download" size="small" @click="openExportDialog('users')">{{ $t('dataExport.exportUsers') }}</el-button>
            </div>
          </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap align-items-center"
            >
              <div class="col-12 col-md-4 col-sm-6 mb-2">
                <el-input
                  v-model="searchQuery"
                  class="search-input"
                  clearable
                  :prefix-icon="Search"
                  :placeholder="$t('common.searchRecords')"
                  aria-controls="datatables"
                  @keyup="search"
                  @clear="handleClearSearch"
                />
              </div>
              <div v-if="userRole !== 'User'" class="mb-2">
                <el-radio-group v-model="statusFilter" size="default" @change="onStatusFilterChange">
                  <el-radio-button :value="'Active'">{{ $t('users.activeUsers') }}</el-radio-button>
                  <el-radio-button :value="'Disabled'">{{ $t('users.disabledUsers') }}</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <paginated-table
              :columns="tableConfig.columns"
              :data="tableConfig.data"
              :pagination="tableConfig.pagination"
              :ready="tableConfig.ready"
              :allow-click="tableConfig.allowClick"
              :enable-edit="tableConfig.enableEdit"
              :enable-delete="tableConfig.enableDelete"
              :actions-inline="tableConfig.actionsInline"
              :show-red-lines="true"
              :red-line-property="'disabled'"
              @row-click="tableConfig.onRowClick"
              @edit="tableConfig.onEdit"
              @update-page="tableConfig.onUpdatePage"
            >
              <template #cell-name="{ row }">
                <div>{{ row.name }}</div>
                <div v-if="row.invitePending" class="invite-status">
                  <el-tag :type="row.inviteExpired ? 'danger' : 'warning'" size="small" disable-transitions>
                    {{ row.inviteExpired ? $t('users.inviteExpired') : $t('users.invitePending') }}
                  </el-tag>
                  <span v-if="row.inviteSentAt" class="invite-sent">{{ $t('users.inviteSentOn', { date: row.inviteSentAt }) }}</span>
                  <el-button link type="primary" size="small" :loading="resendingUserId === row.id" @click.stop="resendInvite(row)">
                    {{ $t('users.resendInvite') }}
                  </el-button>
                </div>
              </template>
            </paginated-table>
          </div>
        </card>
      </div>
    </div>

    <data-export-modal
      v-model:show="showExportDialog"
      :type="exportDialogType"
    />
  </div>
</template>
<script>
import api from "../../services/api"
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import CreateUserForm from './CreateUserForm.vue';
import { defaultUserImage } from '../../components/Image Bytes/imagebytes'
import { getCustomerConfig } from '../Settings/customerConfigHelper';
import Card from "../../components/Card.vue";
import { Search, Download } from '@element-plus/icons-vue';
import { shallowRef } from 'vue';
import { ElButton, ElInput, ElRadioGroup, ElRadioButton, ElTag } from 'element-plus';
import PaginatedTable from "../../components/PaginatedTable.vue";
import DataExportModal from "../../components/DataExportModal.vue";

export default {
  components: {
    Card,
    CreateUserForm,
    PaginatedTable,
    DataExportModal,
    ElButton,
    ElInput,
    ElRadioGroup,
    ElRadioButton,
    ElTag,
  },
  data() {
    return {
      Search: shallowRef(Search),
      Download: shallowRef(Download),
      showExportDialog: false,
      exportDialogType: 'users',
      enableExcelExport: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      tableColumns: [
        { prop: 'image', label: this.$t('common.image'), width: 80, mobileWidth: 80, showOnMobile: true, isImage: true },
        { prop: 'name', label: this.$t('common.name'), minWidth: 200, showOnMobile: true },
        { prop: 'phoneNumber', label: this.$t('users.phoneNumber'), minWidth: 100 },
        { prop: 'email', label: this.$t('users.email'), minWidth: 250 },
      ],
      tableData: [],
      searchQuery: '',
      statusFilter: 'Active',
      showCreateUserForm: false,
      canCreateUser:false,
      initalPage:true,
      userRole: '',
      resendingUserId: null,
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    tableConfig() {
      return {
        columns: this.tableColumns,
        data: this.tableData,
        pagination: this.pagination,
        ready: true,
        allowClick: true,
        enableEdit: false,
        enableDelete: false,
        actionsInline: false,
        onRowClick: this.goToUser,
        onEdit: () => {}, // No-op if not used
        onUpdatePage: this.updatePage,
      }
    }
  },
  created() {
    const token = Cookies.get('accessToken');
    const decodedToken = jwtDecode(token);
    this.userRole = decodedToken.role

    // Check if the cookie exists
    const savedSearchQuery = Cookies.get('usersSearchQuery');
    if (savedSearchQuery) {
      this.searchQuery = savedSearchQuery;
    } else {
      this.searchQuery = '';
    }

    const savedStatusFilter = Cookies.get('usersStatusFilter');
    if (savedStatusFilter) {
      this.statusFilter = savedStatusFilter;
    }

    const savedPage = Cookies.get('usersPage');
    if (savedPage) {
      this.pagination.currentPage = Number(savedPage);
    } else {
      this.pagination.currentPage = 1
    }

    if(this.userRole === 'Admin' || this.userRole === 'SuperAdmin')
    {
      this.canCreateUser = true;
      this.tableColumns.splice(2, 0, { prop: 'userName', label: this.$t('users.username'), minWidth: 150 });
    }
    getCustomerConfig('DefaultPageSize')
    .then(config => {
      if(config === '')
      {
        this.pagination.perPage = 10
      }
      else
      {
        this.pagination.perPage = config
      }
       this.fetchData();
    })
    getCustomerConfig('EnableExcelExport').then(config => {
      this.enableExcelExport = config === '' ? false : config;
    });
  },
  methods: {
    openExportDialog(type) {
      this.exportDialogType = type;
      this.showExportDialog = true;
    },
    openCreateUserForm()
    {
      this.showCreateUserForm = true;
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    closeCreateUserForm()
    {
      this.showCreateUserForm = false;
    },
    search(event)
    {
      this.pagination.currentPage = 1;
      const queryLength = this.searchQuery.length;
      if (event.key === 'Backspace' || event.key === 'Enter') {
        this.fetchData();
      }
      else {
        if (queryLength > 1) {
          if (queryLength % 2 === 0) {
            this.fetchData();
          }
        }
      }
    },
    goToUser(user)
    {
      const decodedToken = jwtDecode(Cookies.get('accessToken'));
      if(user.id !== decodedToken.UserIdentifier && this.canCreateUser === false)
      {
        this.$router.push({ name: 'User', params: { userId: user.id } });
      }
      else
      {
        this.$router.push({ name: 'User Profile Page', params: { userId: user.id } });
      }

    },
    updatePage(item){
      this.pagination.currentPage = item;
      Cookies.set('usersPage', this.pagination.currentPage, { expires: new Date(new Date().getTime() + 1 * 60 * 1000) });
      this.fetchData()
    },
    fetchData()
    {
        let getUsersUrl = ''
        if(this.searchQuery === '')
        {
            Cookies.remove('usersSearchQuery');
            getUsersUrl = `/User?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}`
        }
        else
        {
          Cookies.set('usersSearchQuery', this.searchQuery, { expires: new Date(new Date().getTime() + 1 * 60 * 1000) });
          getUsersUrl = `/User?currentPage=${this.pagination.currentPage}&pageSize=${this.pagination.perPage}&name=${this.searchQuery}`
        }
        if(this.userRole !== 'User')
        {
          if(this.statusFilter === 'Disabled')
          {
            getUsersUrl = getUsersUrl + '&includeDisabled=true&onlyDisabled=true'
          }
        }

        api.get(getUsersUrl)
        .then(response => {
            this.pagination.total = response.data.totalItems;
            this.tableData = response.data.result.map(item => {
            const fullName = [item.firstName, item.lastName].filter(Boolean).join(' ');
            return {
                id: item.id,
                // Invitees who haven't registered have no name yet; the email tells the admin who it is
                name: fullName || item.email,
                // Until registration the username is a placeholder GUID, not something the user chose
                userName: item.emailConfirmed ? item.userName : '',
                email: item.email,
                phoneNumber: item.phoneNumber,
                image: item.userImageThumbnailBytes !== null ? 'data:image/jpeg;base64,' + item.userImageThumbnailBytes : 'data:image/jpeg;base64,' + defaultUserImage,
                disabled: item.disabled,
                invitePending: this.canCreateUser && !item.emailConfirmed,
                inviteExpired: item.invitationExpired,
                inviteSentAt: item.invitationSentAt ? new Date(item.invitationSentAt).toLocaleDateString(this.$i18n.locale) : null
            };
            });
        })
        .catch(error => {
            console.error('API request error:', error); // eslint-disable-line no-console
            this.$toast.danger(this.$t('common.unableToRetrieveData'), { timeout: 0 });
        });
    },
    resendInvite(row)
    {
      this.resendingUserId = row.id;
      api.get(`/identity/ResendConfirmationEmail?userId=${row.id}`)
        .then(() => {
          this.$toast.success(this.$t('users.inviteResent'), { timeout: 1500 });
          this.fetchData();
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
          this.$toast.danger(this.$t('common.failedToSendReconfirmEmail'), { timeout: 2000 });
        })
        .finally(() => {
          this.resendingUserId = null;
        });
    },
    onStatusFilterChange()
    {
      Cookies.set('usersStatusFilter', this.statusFilter, { expires: new Date(new Date().getTime() + 1 * 60 * 1000) });
      Cookies.remove('usersPage');
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleClearSearch()
    {
      Cookies.remove('usersPage');
      this.pagination.currentPage = 1
      this.fetchData();
    }
  },
};
</script>
<style>
.pagination-select {
  width: 200px;
}

.invite-status {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  margin-top: 4px;
}

.invite-sent {
  font-size: 0.75rem;
  color: var(--el-text-color-secondary);
}

</style>
